import { NgFor } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { AppLang, LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [NgFor, RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  private readonly language = inject(LanguageService);

  readonly langs: readonly { id: AppLang; label: string }[] = [
    { id: 'en', label: 'EN' },
    { id: 'es', label: 'ES' },
    { id: 'pt', label: 'PT' }
  ];

  current(): AppLang {
    return this.language.current();
  }

  setLang(lang: AppLang): void {
    this.language.use(lang);
  }
}

